import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const getCommodityList = (includeInactive) =>
  axios.get(`${apiUrl}systemLists/PRDCAT/items?includeInactive=${includeInactive}`);

export const getQuestionCategories = (includeInactive) =>
  axios.get(`${apiUrl}systemLists/QSTCAT/items?includeInactive=${includeInactive}`);

export const requestGetEmploymentTypeItems = (includeInactive) =>
  axios.get(`${apiUrl}systemLists/EMPTYP/items?includeInactive=${includeInactive}`);

export const requestGetEmploymentStatusItems = (includeInactive) =>
  axios.get(`${apiUrl}systemLists/EMPSTA/items?includeInactive=${includeInactive}`);

export const requestGetLanguagesItems = (includeInactive) =>
  axios.get(`${apiUrl}systemLists/LANG/items?includeInactive=${includeInactive}`);

export const requestGetAppliedFor = (includeInactive) =>
  axios.get(`${apiUrl}systemLists/POSAPP/items?includeInactive=${includeInactive}`);

export const requestGetHoursOfWorkAvailability = (includeInactive) =>
    axios.get(`${apiUrl}systemLists/WRKHRS/items?includeInactive=${includeInactive}`);

export const requestGetTravelTypes = (includeInactive) =>
    axios.get(`${apiUrl}systemLists/MTRTYP/items?includeInactive=${includeInactive}`);
